var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileCheckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 12,
    height: 15,
    rx: 3,
    fill: "#D3E9E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.875V5.6C15 4.33988 15 3.70982 14.7548 3.22852C14.539 2.80516 14.1948 2.46095 13.7715 2.24524C13.2902 2 12.6601 2 11.4 2H6.6C5.33988 2 4.70982 2 4.22852 2.24524C3.80516 2.46095 3.46095 2.80516 3.24524 3.22852C3 3.70982 3 4.33988 3 5.6V13.4C3 14.6601 3 15.2902 3.24524 15.7715C3.46095 16.1948 3.80516 16.539 4.22852 16.7548C4.70982 17 5.33988 17 6.6 17H9M10.5 8.75H6M7.5 11.75H6M12 5.75H6M10.875 14.75L12.375 16.25L15.75 12.875",
    stroke: "#24352F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCheckIcon);
export default __webpack_public_path__ + "static/media/file-check-icon.7ef948ea.svg";
export { ForwardRef as ReactComponent };